import _ from "lodash";

const mapSportCodeToFieldName = (sportCode) => {
  const map = {
    "girls-volleyball": "girlsvolleyball"
  };

  return _.get(map, sportCode, sportCode);
};

const mapResourceToQueryName = (resourceName, raFetchType) => {
  const map = {
    games: {
      GET_LIST: "GamesSearch",
      GET_ONE: "GameByID",
      CREATE: "CreateGame",
      DELETE: "DeleteGameByID",
      UPDATE: "UpdateGame"
    },
    locations: {
      GET_LIST: "LocationsSearch",
      GET_ONE: "LocationByID",
      CREATE: "CreateLocation",
      UPDATE: "UpdateLocation"
    },
    seasonTeams: {
      GET_LIST: "SeasonTeamsSearch",
      GET_ONE: "SeasonTeamByID"
    },
    availableSeasons: {
      GET_LIST: "AvailableSeasons"
    },
    sportCodes: {
      GET_LIST: "SportCodes"
    },
    comboLocations: {
      GET_LIST: "CombinedLocationsSearch",
      GET_ONE: "LocationByID",
      CREATE: "UpsertLocation"
    },
    footballGames: {
      UPDATE: "UpdateFootballGame"
    },
    "girls-volleyballGames": {
      UPDATE: "UpdateGirlsVolleyballGame"
    }
  };

  const queryName = _.get(map, [resourceName, raFetchType]);
  if (!queryName) {
    console.warn(
      `Resource ${resourceName} with ${raFetchType} does not have a value in mapResourceToQuery`
    );
  }

  return queryName;
};

const getQuery = (introspectionResults, queryName) => {
  const { queries } = introspectionResults;
  return queries.find((query) => query.name === queryName);
};

const getArgValue = (arg) => {
  const { type = {} } = arg;
  const argTypeName = _.get(type, "name");
  const argOfTypeName = _.get(type, "ofType.name");
  const isRequired = _.get(type, "kind") === "NON_NULL";
  const value = argTypeName ? argTypeName : argOfTypeName;
  return isRequired ? value + "!" : value;
};

const buildVariables = (query) => {
  const { args = [] } = query;

  return args.map((arg) => `$${arg.name}: ${getArgValue(arg)}`).join("\n");
};

const buildList = (query) => {
  const { args = [] } = query;
  return args.map((arg) => `${arg.name}: $${arg.name}`).join("\n");
};

const getTotal = (searchResult) => {
  const haveNestedResults = _.get(searchResult, "data");

  if (haveNestedResults) {
    return (
      _.get(searchResult, "total") ||
      _.get(searchResult, "data", []).length ||
      0
    );
  } else {
    return searchResult.length || 0;
  }
};

const DEFAULT_START_DATE = "2018-01-01";

const DEFAULT_END_DATE = "2025-12-31";

export {
  mapResourceToQueryName,
  getQuery,
  buildVariables,
  buildList,
  getTotal,
  mapSportCodeToFieldName,
  DEFAULT_START_DATE,
  DEFAULT_END_DATE
};
